import { fetchWidgetsStageData } from '@wix/bob-widget-services';
import {
  AppManifest,
  type ContextParams,
  type EditorSDK,
  type GfppConfig,
  type GfppDesktopConfig,
  type GfppMobileConfig,
} from '@wix/platform-editor-sdk';
import { EditorSDKUtils } from '../utils/editorSDKUtils';
import { announcementsMobilePresets, presets } from '../utils/presets';

const controllerId = '7fdf5576-9d52-4c0a-9840-6e226f2ec415-t0i9y';

export const modifyAppManifest = async (
  options: any,
  editorSDK: EditorSDK,
  context: ContextParams,
): Promise<AppManifest> => {
  const { appManifestBuilder } = options;
  const baseManifest = await fetchWidgetsStageData(options);

  const manifest = appManifestBuilder.withJsonManifest(baseManifest).build();

  // Hide elements panel on mobile
  setAppMobileGfpp(manifest);

  const editorUtils = new EditorSDKUtils(editorSDK as any);
  const isStudio = editorUtils.getIsStudio(context);
  const isMobile = await editorUtils.isMobileViewport();

  setAppPresetsData(manifest, isMobile, isStudio);
  return manifest;
};

export const setAppMobileGfpp = (appManifest: AppManifest) => {
  const appStageDataDefault =
    appManifest.controllersStageData![controllerId].default;
  const mobileAppGfpp = (appStageDataDefault.gfpp as GfppConfig)
    .mobile as GfppMobileConfig;
  // @ts-expect-error
  mobileAppGfpp.iconButtons.add = { behavior: 'HIDE' };
  // @ts-expect-error
  mobileAppGfpp.widgetDesign = appStageDataDefault.gfpp.desktop.widgetDesign;
};

export const setAppPresetsData = (
  appManifest: AppManifest,
  isMobile: boolean,
  isStudio: boolean,
) => {
  const appStageDataDefault =
    appManifest.controllersStageData![controllerId].default;
  const desktopAppGfpp = (appStageDataDefault.gfpp as GfppConfig)
    .desktop as GfppDesktopConfig;
  const mobileAppGfpp = (appStageDataDefault.gfpp as GfppConfig)
    .mobile as GfppMobileConfig;

  const myPresets = presets(!isStudio).ANNOUNCEMENTS;

  if (isStudio) {
    desktopAppGfpp.widgetPresets = {
      presets: isMobile ? announcementsMobilePresets : myPresets,
    };
  } else {
    desktopAppGfpp.widgetPresets = { presets: myPresets };
    // @ts-expect-error
    mobileAppGfpp.widgetPresets = {
      presets: announcementsMobilePresets,
    };
  }
};
